import {dateFromServer} from "@/functions/dates.ts";
import {GetRoleStaff, PersonRole, WorkspaceId} from "@/sdk.ts";

export class PersonRoleStaff {
  readonly person_role: Exclude<PersonRole, "coachee">;
  workspace_id: WorkspaceId; // Not required
  created_at: Date;
  updated_at: Date | null;

  constructor(props: GetRoleStaff) {
    this.person_role = props.person_role;
    this.workspace_id = props.workspace_id; // Not required
    this.created_at = dateFromServer(props.created_at);
    this.updated_at = props.updated_at ? dateFromServer(props.updated_at) : null;
  }
}